// mutation types
export const SET_ERROR = "setError";
import PouchDB from "pouchdb";
var db = new PouchDB("agricactus");

const state = {
  asistencias: [],
  test: [],
  isAsistencias: false,
  jornadaId: 0, //NEW
  areaId: 0, //NEW,
  actividadId: 0, //NEW,
  semaforo: "danger"
};

const getters = {};

const actions = {
  async getAsistencias(context) {
    context.commit("resetAsistencia");
    await db
      .allDocs({ include_docs: true })
      .then(function(result) {
        const data = [];
        result.rows.map(x => data.push(x.doc));
        console.log(data);
        context.commit("storeAsistencia", data);
      })
      .catch(function(err) {
        console.log(err);
      });
    context.commit("loadedAsistencias");
  },

  putAsistencia(context, { user_id, jornada_id, date, actividadId, cuadroId }) {
    let randomStr = Math.random()
      .toString(36)
      .substring(7);
    const id = new Date().toISOString() + randomStr + user_id.toString();
    db.put({
      _id: id,
      date,
      jornadaId: jornada_id,
      usuarioId: user_id,
      actividadId,
      cuadroId
    })
      .then(function() {
        context.dispatch("getAsistencias");
      })
      .catch(function(err) {
        console.log(err);
      });
  },

  updateAsistencia(context, data) {
    db.destroy().then(() => {
      db = new PouchDB("agricactus");
      if (data.length !== 0) {
        data.forEach(async user => {
          const date = new Date()
            .toJSON()
            .slice(0, 10)
            .replace(/-/g, "/");
          const jornada_id = user.jornadaId;
          const user_id = user.usuarioId;
          const actividadId = user.actividadId;
          const cuadroId = user.cuadroId;
          let randomStr = Math.random()
            .toString(36)
            .substring(7);
          const id = new Date().toISOString() + randomStr + user.id.toString();
          await db
            .put({ _id: id, date, jornada_id, user_id, actividadId, cuadroId })
            .then(function() {})
            .catch(function(err) {
              console.log(err);
            });
        });
        // context.dispatch("getAsistencias")
      }
      context.commit("storeAsistencia", data);
      context.commit("loadedAsistencias");
    });
  },

  getJornadaId() {
    return state.jornadaId;
  },

  getAreaId() {
    return state.areaId;
  },

  getActividadId() {
    return state.actividadId;
  }
};

const mutations = {
  resetAsistencia(state) {
    state.asistencias = [];
  },
  loadedAsistencias(state) {
    state.isAsistencias = true;
  },
  changeSemaforo(state, semaforo) {
    state.semaforo = semaforo;
  },
  storeAsistencia(state, asistencias) {
    state.asistencias = asistencias;
  },
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  saveActividad(state, actividadId) {
    state.actividadId = actividadId;
  },
  saveJornada(state, jornadaId) {
    state.jornadaId = jornadaId;
  },
  saveArea(state, areaId) {
    state.areaId = areaId;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
